import { useEffect, useState } from "react";
import { Loader2, Eye } from "lucide-react";
import { AdminShell } from "../components/AdminShell";
import { LandingRenderer } from "../components/LandingRenderer";
import { api } from "../lib/api";

const PreviewBody = () => {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(false);
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    api.get("/admin/landing/preview-data")
      .then((r) => { setContent(r.data.content); setMatches(!!r.data.draft_matches_published); })
      .catch(() => setError(true));
  }, []);

  useEffect(() => {
    let el = document.head.querySelector('meta[name="robots"]');
    let created = false;
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
      created = true;
    }
    el.setAttribute("content", "noindex, nofollow");
    return () => {
      if (created) el.remove();
      else el.setAttribute("content", "");
    };
  }, []);

  if (error) {
    return <p className="py-16 text-center text-sm font-semibold text-hz-error" data-testid="landing-preview-error">No se pudo cargar el borrador.</p>;
  }
  if (!content) {
    return <div className="flex items-center justify-center py-20 text-sm font-semibold text-hz-ink/60"><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Cargando borrador…</div>;
  }
  return (
    <div>
      <div className={`mb-4 flex items-center gap-2 rounded-xl border px-4 py-3 ${matches ? "border-hz-cyan/40 bg-hz-cyan/10" : "border-hz-warning/50 bg-hz-warning/10"}`} data-testid="landing-preview-banner">
        <Eye className={`h-5 w-5 shrink-0 ${matches ? "text-hz-cyan" : "text-hz-warning"}`} />
        <p className="text-sm font-bold text-hz-ink">
          {matches ? "Esta vista previa corresponde a la versión publicada." : "Vista previa: estos cambios todavía no están publicados."}
        </p>
      </div>
      <div className="overflow-hidden rounded-2xl border border-hz-gray/40 bg-white" data-testid="landing-preview-canvas">
        <LandingRenderer content={content} />
      </div>
    </div>
  );
};

const AdminLandingPreview = () => (
  <AdminShell roles={["admin"]} title="Vista previa de Landing" subtitle="Contenido del borrador actual" testId="landing-preview">
    {() => <PreviewBody />}
  </AdminShell>
);

export default AdminLandingPreview;
